import { ValidationFailure } from "@/api/models/FluentValidation/Results/validation-failure";
import { AnfrageService, GutachtenService } from "@/api/service-index";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { PortalContextService } from "../../services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";

@Injectable({
    providedIn: 'root'
})
export class GetGutachtenValidationErrorsResolver implements Resolve<{ [key: string]: ValidationFailure[]; } | null> {
    constructor(protected anfrageService: AnfrageService, 
        protected portalContextService: PortalContextService,
         protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{ [key: string]: ValidationFailure[]; } | null> {

        await this.unfinishedHttpMethodsService.waitForAll();

        const id: string = this.portalContextService.CurrentItemContext.id;

        if (id) {
            return this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: id, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: id }).toPromise()
        }

        return of(null).toPromise();
    }
}